import getRouteWindowTitle from './get-route-window-title';

/**
 * @param {import("vue-router").Route} route
 * @returns {string} windowTitle
 */
export default function (route) {
  return (document.title = getRouteWindowTitle(route));
}
